import type { Country } from '../entities/Country';

export const mapCurrencyToCountry = (currency: string) => {
  switch (currency) {
    case 'AUD':
      return 'AU';
    case 'HKD':
      return 'HK';
    case 'IDR':
      return 'ID';
    case 'MYR':
      return 'MY';
    case 'NZD':
      return 'NZ';
    case 'PHP':
      return 'PH';
    case 'SGD':
      return 'SG';
    case 'THB':
      return 'TH';
    default:
      return 'AU';
  }
};

export const checkAdvNationMapping = (
  advertiserNation: string | undefined,
  currency: string | undefined,
) => {
  const country =
    currency !== undefined ? mapCurrencyToCountry(currency) : advertiserNation;

  return country as Country;
};
